import baseAPI from '@/http'

const router = 'api/municipio-resunmo'

export const resumoMunicipioApi = {
    create: (municipio) => baseAPI.post(`${router}/cadastrar-resumo-municipio`, municipio),
    remove: (resumoMunicipioId) => baseAPI.delete(`${router}/${resumoMunicipioId}`),
    list: (municipioId) => baseAPI.get(`${router}/obter-todos/${municipioId}`),
    find: (resumoMunicipioId) => baseAPI.get(`${router}/${resumoMunicipioId}`),
    update: (resumoMunicipio) => baseAPI.put(`${router}/atualizar-resumo-municipio`, resumoMunicipio),
    downloadPdf: (municipioId) => baseAPI.get(`${router}/download-resumo/${municipioId}`, { responseType: 'blob' }),


}
